import  {  useState } from "react";

import {  useAppSelector } from '../../redux/store/storehooks';
import Spinner from "../../components/_common/Spinner";
import './style.css'
import  Table, { ColumnsType } from "antd/lib/table";
import './style.css'

export interface InputProps {
    permission: any
  }

const ParsicMasterInfo = ({permission}:InputProps) =>{
    const columns: ColumnsType<any> = [
        {title: 'DBList_Name ',dataIndex: 'DBList_Name',key: 'DBList_Name'},
        {title: 'DBList_Alias ',dataIndex: 'DBList_Alias',key: 'DBList_Alias'},
        {title: 'DBList_PreString ',dataIndex: 'DBList_PreString',key: 'DBList_PreString'},
        {title: 'DBList_CreationDate ',dataIndex: 'DBList_CreationDate',key: 'DBList_CreationDate'},
        {title: 'DBList_Server ',dataIndex: 'DBList_Server',key: 'DBList_Server'},
        {title: 'DBList_DB ',dataIndex: 'DBList_DB',key: 'DBList_DB'},
        {title: 'DBList_Username ',dataIndex: 'DBList_Username',key: 'DBList_Username'},
        {title: 'DBList_Password ',dataIndex: 'DBList_Password',key: 'DBList_Password'},
        {title: 'DBList_Description ',dataIndex: 'DBList_Description',key: 'DBList_Description'},
        {title: 'DBList_GeographicalID ',dataIndex: 'DBList_GeographicalID',key: 'DBList_GeographicalID'},
        {title: 'Int_Order ',dataIndex: 'Int_Order',key: 'Int_Order'},
        {title: 'Str_FirstAdmitDate ',dataIndex: 'Str_FirstAdmitDate',key: 'Str_FirstAdmitDate'},
        {title: 'Str_LastAdmitDate ',dataIndex: 'Str_LastAdmitDate',key: 'Str_LastAdmitDate'},
    ];
   
    const myStore = useAppSelector((state) => state)
    const [isLoading,setIsLoading] = useState(false);
   
    return(
        <>
        {
            isLoading === false  && permission &&(
            <>
                <div className="inner-tabs_content">               
                    <Table scroll={{x:"max-content"}} dataSource={myStore.generalInfo.ParsicMasterInfo} columns={columns} 
                    rowClassName={(record) => (record.DBList_IsActive ? "green-back" : record.DBList_IsActive ? "yellow-back":"white-back")}
                    />                                   
            </div>
            </> 
            )
        }
        {!permission && (
            <center style={{padding:'30px'}}> <span style={{color:'red',paddingTop:'20px'}}>شما به اطلاعات این صفحه دسترسی ندارید!</span></center>
        )}
        {
          isLoading === true  && (
          <Spinner />
        )
        }
        </>  
          
        )
}

export default ParsicMasterInfo;



